import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getDemandeOrigine } from '../utils/demandeOrigine';

const ContactRequestDetailModal = ({ 
  demande, 
  isOpen, 
  onClose,
  onMarkAsProcessed
}) => {
  const navigate = useNavigate();
  if (!isOpen || !demande) return null;

  const getStatusBadge = (statut) => {
    if (statut === 'nouveau' || statut === 'en_attente') {
      return 'bg-orange-100 text-orange-700';
    } else if (statut === 'en_cours') {
      return 'bg-blue-100 text-blue-700';
    } else {
      return 'bg-green-100 text-green-700';
    }
  };

  const getStatusLabel = (statut) => {
    if (statut === 'nouveau') return <><i className="bi bi-asterisk mr-1"></i>Nouveau</>;
    if (statut === 'en_attente') return <><i className="bi bi-hourglass-split mr-1"></i>En attente</>;
    if (statut === 'en_cours') return <><i className="bi bi-clipboard-check mr-1"></i>En cours</>;
    return <><i className="bi bi-check-lg mr-1"></i>Traité</>;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Détail de la demande</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <i className="bi bi-x-lg text-2xl"></i>
            </button>
          </div>
          
          {/* Statut */}
          <div className="mb-6">
            <span className={`px-4 py-2 rounded-full text-sm font-bold ${getStatusBadge(demande.statut)}`}>
              {getStatusLabel(demande.statut)}
            </span>
          </div>
          
          {/* Info contact */}
          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <h3 className="font-bold text-gray-900 mb-3">Informations du contact</h3>
            <div className="space-y-2">
              <p><strong>Nom:</strong> {demande.nom}</p>
              <p>
                <strong>Email:</strong>{' '}
                <a href={`mailto:${demande.email}`} className="text-blue-600">
                  {demande.email}
                </a>
              </p>
              <p><strong>Téléphone:</strong> {demande.telephone || 'Non renseigné'}</p>
              <p><strong>Origine:</strong> {getDemandeOrigine(demande)}</p>
            </div>
          </div>
          
          {/* Bien concerné */}
          <div className="bg-blue-50 p-4 rounded-lg mb-6">
            <h3 className="font-bold text-gray-900 mb-3">Bien concerné</h3>
            <p className="font-semibold text-lg">{demande.property_titre || 'Non renseigné'}</p>
            {demande.property_reference && (
              demande.property_id ? (
                <button
                  onClick={() => {
                    onClose();
                    navigate(`/properties/${demande.property_id}/view`);
                  }}
                  data-testid="demande-detail-bien-ref"
                  title="Ouvrir la fiche du bien"
                  className="text-blue-600 font-semibold hover:text-blue-800 hover:underline"
                >
                  Réf: {demande.property_reference}
                </button>
              ) : (
                <p className="text-gray-600" data-testid="demande-detail-bien-ref">
                  Réf: {demande.property_reference}
                </p>
              )
            )}
          </div>
          
          {/* Message */}
          <div className="mb-6">
            <h3 className="font-bold text-gray-900 mb-3">Message</h3>
            <p className="text-gray-700 whitespace-pre-line bg-gray-50 p-4 rounded-lg">
              {demande.message}
            </p>
          </div>
          
          {/* Date */}
          <p className="text-sm text-gray-500 mb-6">
            Reçu le {new Date(demande.created_at).toLocaleDateString('fr-FR', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </p>
          
          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50"
            >
              Fermer
            </button>
            {(demande.statut === 'nouveau' || demande.statut === 'en_attente') && (
              <button
                onClick={() => {
                  onMarkAsProcessed(demande.id);
                  onClose();
                }}
                className="flex-1 px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 flex items-center justify-center gap-2"
              >
                <i className="bi bi-check-circle-fill"></i>
                Marquer comme traité
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactRequestDetailModal;
